export default "__VITE_PUBLIC_ASSET__aa801426__"